import { useEffect } from 'react'
import { createPortal } from 'react-dom'
import { ClientApi } from '../../../../services/clientApi'
import { useStore } from '../../../../store/store'
import { NuiMessages } from '../../../../utils/ClientEvents'
import './Frames.css'

export const Frames = () => {
    const visible = useStore(state => state.raceFramesVisible)
    const setVisible = useStore(state => state.setRaceFramesVisible)

    useEffect(() => {
        ClientApi.on(NuiMessages.RACE_FRAMES, ({ visible }: { visible: boolean }) => {
            setVisible(visible)
        })
    }, [setVisible])

    if (!visible) return null

    return createPortal(
        <div className="frames">
            <div className='upper-frame'></div>
            <div className='lower-frame'></div>
        </div>,
        document.body
    )
}
